'use client'

import { INotice } from '@/types/pages'
import Link from 'next/link'
import { useState } from 'react'
import NoticeDetail from '@/app/notice/[id]/_components/NoticeDetail'
import { useTranslation } from 'react-i18next'
import { motion, AnimatePresence } from 'framer-motion'
import Image from 'next/image'
import { GA_EVENTS } from '@/utils/analytics'
interface INoticeItemProps {
  notice: INotice
}

const NoticeItem: React.FC<INoticeItemProps> = ({ notice }) => {
  const { t } = useTranslation('notice')
  const [isModalOpen, setIsModalOpen] = useState(false)

  const description = notice.description
  const truncatedDescription =
    description.length > 68 ? `${description.slice(0, 68)}...` : description

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleNoticeClick = () => {
    GA_EVENTS.NOTICE_VIEW(notice.title)
  }

  return (
    <li>
      <div className="sm:hidden">
        <Link
          href={`/notice/${notice.id}`}
          className="sm:h-[385px] flex py-6 flex-col border-b"
          onClick={handleNoticeClick}
        >
          <div className="flex gap-2 items-center mb-2">
            <p className="py-1 px-2 text-[11px] font-pretendard-semibold text-white dark:text-black bg-main-light-2 dark:bg-main-dark-2 rounded-md">
              {t(notice.category)}
            </p>
            <p className="font-pretendard-regular text-[13px] text-main-light-4 dark:text-main-dark-4">
              {notice.createdAt}
            </p>
          </div>
          <p className="mb-[6px] font-pretendard-bold text-[19px] text-main-light-2 dark:text-main-dark-2">
            {notice.title}
          </p>
          <Image
            src={notice.image}
            alt="notice"
            width={327}
            height={188}
            className="mx-auto w-full rounded-lg mt-[10px] mb-[10px]"
          />
          <div>
            <span className="font-pretendard-regular text-[15px] text-main-light-2 dark:text-main-dark-2">
              {truncatedDescription}
            </span>
            <span className="ml-2 font-pretendard-bold text-[13px] text-primary">
              {t('more')}
            </span>
          </div>
        </Link>
      </div>

      {/* 데스크탑 환경에서는 모달로 표시 */}
      <div className="hidden sm:block">
        <button
          onClick={() => {
            setIsModalOpen(true)
            handleNoticeClick()
          }}
          className="sm:h-[385px] flex py-6 flex-col border-b"
        >
          <div className="flex gap-2 items-center mb-2">
            <p className="py-1 px-2 text-[11px] font-pretendard-semibold text-white dark:text-black bg-main-light-2 dark:bg-main-dark-2 rounded-md">
              {t(notice.category)}
            </p>
            <p className="font-pretendard-regular text-[13px] text-main-light-4 dark:text-main-dark-4">
              {notice.createdAt}
            </p>
          </div>
          <p className="text-left mb-[6px] font-pretendard-bold text-[19px] text-main-light-2 dark:text-main-dark-2">
            {notice.title}
          </p>

          <Image
            src={notice.image}
            alt="notice"
            width={327}
            height={188}
            className="mx-auto rounded-lg mt-[10px] mb-[10px]"
          />
          <div className="text-left">
            <span className="font-pretendard-regular text-[15px] text-main-light-2 dark:text-main-dark-2">
              {truncatedDescription}
            </span>
            <span className="ml-2 font-pretendard-bold text-[13px] text-primary">
              {t('more')}
            </span>
          </div>
        </button>

        <AnimatePresence>
          {isModalOpen && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
              onClick={handleCloseModal}
            >
              <div
                className="bg-white dark:bg-black py-7 px-2 rounded-lg max-w-sm w-full relative"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={handleCloseModal}
                  className="absolute top-2 right-4 text-3xl p-2"
                >
                  &times;
                </button>
                <NoticeDetail notice={notice} />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </li>
  )
}

export default NoticeItem
